
import Vue from 'vue'
import { lotSellerApi, LotSellerDto } from '@/api/lotSeller'
import { formatAddress } from '@/utils/addresses'
import HistoryToolTip from '@/components/HistoryToolTip.vue'
import TitlePage from '@/components/TitlePage.vue'
import { handleAxiosException } from '@/api'
import { debounce, DebouncedFunc } from 'lodash'
import LotSellerDialog from './LotSellerDialog.vue'

export default Vue.extend({
  components: { LotSellerDialog, HistoryToolTip, TitlePage },
  data() {
    return {
      error: '',
      loading: false,
      editDialog: {
        active: false,
        lotSeller: undefined as LotSellerDto|undefined,
      },
      lotSellers: [] as LotSellerDto[],
      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
      lengthPagination: 1,
      infoDetails: [
        { key: 'phonenumber', icon: 'mdi-phone', formatter: (item) => item.phonenumber },
        { key: 'email', icon: 'mdi-at', formatter: (item) => item.email },
        { key: 'address', icon: 'mdi-map-marker', formatter: (item) => formatAddress(item.address, this.$i18n.locale) },
      ] as {key: string, formatter: (item: LotSellerDto) => string, icon: string}[],
      name: '',
      debouncedLoadData: null as DebouncedFunc<() => Promise<void>> | null,
    }
  },
  methods: {
    formatAddress,
    debounce,
    setPage(page: number) {
      if (page !== this.page) {
        this.$router.push({ query: { page: page.toString() } })
      }
    },
    create() {
      this.editDialog = {
        active: true,
        lotSeller: undefined,
      }
    },
    edit(p: LotSellerDto) {
      this.editDialog = {
        lotSeller: p,
        active: true,
      }
    },
    onSuccessSave(p: LotSellerDto) {
      this.snackbarSuccessRegistration = {
        active: true,
        message: this.$t('success.save', { name: p.name ?? `${p.firstname} ${p.name}` }) as string,
      }
      this.editDialog.active = false
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const page = (await lotSellerApi.getAllLotSellers({ name: this.name, page: this.page - 1, size: 10 }))
        this.lengthPagination = page.totalPages
        this.lotSellers = page.content
      } catch (err) {
        this.error = this.$t(handleAxiosException(err, () => 'error.loading')) as string
      }
      this.loading = false
    },
  },
  computed: {
    page(): number {
      return parseInt(this.$route.query.page as string ?? '1', 10)
    },
  },
  watch: {
    page() {
      this.loadData()
    },
  },
  mounted() {
    this.loadData()
    this.debouncedLoadData = debounce(this.loadData, 500)
  },
})
